<template>
  <b-btn v-if="authControl" v-bind="attrs" v-on="$listeners">
    <div class="brb-btn-container" :class="[{ loading }, btnClass]">
      <font-awesome-icon
        v-if="startIcon"
        :icon="startIcon"
        v-bind="startIconAttrs"
        class="ml-1"
      />

      <div class="d-flex">
        <slot>
          <span v-if="text" :class="{ 'single-line': !multiline }">
            {{ text }}
          </span>
          <font-awesome-icon v-else-if="icon" :icon="icon" v-bind="iconAttrs" />
        </slot>
      </div>

      <font-awesome-icon
        v-if="endIcon"
        :icon="endIcon"
        v-bind="endIconAttrs"
        class="mr-1"
      />

      <div v-if="loading" class="brb-btn-loading-wrapper">
        <b-spinner small />
      </div>
    </div>
  </b-btn>
</template>

<script>
export default {
  name: 'BrbBtn',
  props: {
    text: String,
    auth: [String, Array],
    icon: [String, Array],
    iconAttrs: Object,
    permissionScope: String,
    startIcon: [String, Array],
    startIconAttrs: Object,
    endIcon: [String, Array],
    endIconAttrs: Object,
    btnClass: [String, Array, Object],
    loading: Boolean,
    multiline: Boolean
  },
  computed: {
    authControl() {
      if (this.auth) {
        return this.$hasPermission(this.auth, this.permissionScope)
      }

      return true
    },
    attrs() {
      const attrs = { ...this.$attrs }

      attrs.disabled = attrs.disabled || this.loading

      return attrs
    }
  }
}
</script>

<style lang="scss" scoped>
.brb-btn-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  * {
    transition: opacity 0.1s ease-in-out;
  }

  &.loading {
    *:not(:last-child) {
      opacity: 0;
    }
  }
  .brb-btn-loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
